import styled from 'styled-components';

export const HorizontalScroller = styled.div`
  overflow-x: scroll;
`;
